















import { Vue, Component, Prop } from "vue-property-decorator";
import { SelectableTag } from "@api/models/SelectableTag";
import CloseBtn from "@service/components/common/close-button/CloseButton.vue";
import { Debounce } from "vue-debounce-decorator";

@Component({
    components: { CloseBtn }
})
export default class TagListDates extends Vue {

    @Prop() tags: SelectableTag[];

    resizeObserver: ResizeObserver | null = null;

    mounted() {
        this.setResizeObserver();
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.updateList)
    }

    setResizeObserver() {
        window.addEventListener('resize', this.updateList);
        this.turnParentStyle()
        this.updateList()
    }

    getChildren(): HTMLElement[] {
        return Array.from(this.$el.children.item(0)?.children || []).filter((child) => child.tagName.toLowerCase() !== "button") as HTMLElement[];
    }

    turnParentStyle() {
        const parent = this.$el?.parentElement;

        if(!parent) {return;}

        parent.style.gridTemplateColumns = "minmax(min-content, min-content) minmax(0px, 310px)";
    }

    @Debounce(40)
    updateList() {
        const children = this.getChildren();
        const containerWidth = this.$el.clientWidth;
        const parent = this.$el?.parentElement;

        if(this.tagsForRender.length && !children.length) {
            throw Error("Child elements not found.")
        }

        if(parent) {
            parent.style.gridTemplateColumns = "minmax(min-content, min-content) minmax(0px, max-content)";
        }

        children.reduce((acc, current) => {
            if(current.hidden) {
                current.hidden = false;
            }

            const newValue = acc + current.clientWidth;

            if(containerWidth < newValue) {
                current.hidden = true;
            }

            return newValue;
        }, 10);

        if((children as HTMLElement[]).some((element) => element.hidden) && parent) {
            parent.style.gridTemplateColumns = "minmax(min-content, min-content) minmax(0px, 310px)";
        }
    }

    onSelectTag(item: SelectableTag) {
        this.$emit('selectTag', item);
    }

    get tagsForRender() {
        const selected = this.tags.filter((tag) => tag.isSelected);
        return selected.length ? selected : this.tags;
    }
}
